import { N53 } from "./PesoSalesAndNumberOfCustomers/N53";
import { N53_Share } from "./ShareByCustomerGroupSales/N53";

export const RegionCustomerSales = {
  "sections": [
    N53,
    N53_Share
  ]
}